// extracted by mini-css-extract-plugin
export default {"container":"container_Ug9he","webViewButton":"webViewButton_ltLiZ"};